export const tr = {
    'back-to-creatives': 'Kreatiflerime dön',
    'back-to-ideas': 'Kreatifler için fikirlere dön',
    'back-to-presets': 'Şablonlara dön',
    cancel: 'İptal',
    create: 'Oluştur',
    'create-error': 'Kreatif oluşturulurken hata oluştu. Lütfen, az sonra tekrar deneyin.',
    'create-video-error': 'Video kreatifi oluşturulurken hata oluştu. Daha sonra tekrar deneyin.',
    'crop-revert-confirm-message': 'Görselin düzenlemesi iptal edilsin mi?',
    'fetch-error': 'Kreatif verileri alınırken hata oluştu. Lütfen, az sonra tekrar deneyin.',
    'fetch-video-error': 'Video kreatifi verileri alınırken hata oluştu. Daha sonra tekrar deneyin.',
    'overlay-name': 'Yeni banner',
    'parameters-errors': 'Kreatif oluşturulamıyor. Hatalar: {errors}',
    'preview-title': 'Önizleme',
    'to-creatives': 'Eklenenler listesine dön',
    'video-ad-name': 'Yeni video kreatif',
    'video-addition-name': 'Yeni video eklentisi',
    'video-cpm-audio-name': 'Yeni ses kreatifi'
};
